import Product from '@/types/Product'
import CartProduct from '@/types/CartTypes'

export const priceInDollars = (priceInCents: number) => {
  const dollars = (priceInCents / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
  })
  return `$${dollars}`
}

export const priceForPlan = (plan: Product) => {
  const isUSD = localStorage.getItem('isUSD') === 'false'
  const dollars = priceInDollars(plan.price)
  if (plan.period_unit === 'month' || plan.period_unit == 'year') {
    if(isUSD){
      return `${dollars} / ${plan.period_unit}`
    }
    else {
      return `${dollars} USD / ${plan.period_unit}`
    }
  }
  else{
    if(isUSD){
      return dollars
    }
    else {
      return `${dollars} USD`
    }
  }
}

export const priceForCartItem = (item: CartProduct): string => {
  const qty = item.quantity || 1

  if (item.id === 'CTIU-MONTH') {
    const total =
      qty > 1 ? 12900 + (qty - 1) * 4500 : 12900
    return priceInDollars(total)
  }

  return priceInDollars(item.price * qty)
}

export const calculateCartItemTotal = (item: CartProduct): number => {
  const qty = item.quantity || 1

  if (item.id === 'CTIU-MONTH') {
    return qty > 1 ? 12900 + (qty - 1) * 4500 : 12900
  }

  return item.price * qty
}